import * as Sentry from '@sentry/browser';
const maxWaitTime = 1500;
const domain =
    typeof window == 'undefined' ? 'localhost' : window.location.host.replace(/:\d+/, '');
const indexedDbTableName = 'ActionButton';

function timeoutPromise(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

function getFromString(name, text) {
    if (typeof text !== 'string') {
        return;
    }
    var nameEQ = name + '=',
        ca = text.split(/[;&]/),
        i,
        c;
    for (i = 0; i < ca.length; i++) {
        c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1, c.length);
        }
        if (c.indexOf(nameEQ) === 0) {
            return c.substring(nameEQ.length, c.length);
        }
    }
}

function replaceInString(str, key, value) {
    if (str.indexOf('&' + key + '=') > -1 || str.indexOf(key + '=') === 0) {
        // find start
        var idx = str.indexOf('&' + key + '='),
            end,
            newstr;
        if (idx === -1) {
            idx = str.indexOf(key + '=');
        }
        // find end
        end = str.indexOf('&', idx + 1);
        if (end !== -1) {
            newstr =
                str.substr(0, idx) +
                str.substr(end + (idx ? 0 : 1)) +
                '&' +
                key +
                '=' +
                value;
        } else {
            newstr = str.substr(0, idx) + '&' + key + '=' + value;
        }
        return newstr;
    } else {
        return str + '&' + key + '=' + value;
    }
}

function getBestCandidate(cookieSourceList) {
    let candidates = [];

    cookieSourceList.forEach(function(cookieSource) {
        if (
            cookieSource.val &&
            cookieSource.val !== 'null' &&
            cookieSourceList.val !== 'undefined'
        ) {
            candidates[cookieSource.val] = candidates[cookieSource.val]
                ? candidates[cookieSource.val] + 1
                : 1;
        }
    });

    let bestnum = 0;
    let candidate;
    for (var item in candidates) {
        if (candidates[item] > bestnum) {
            bestnum = candidates[item];
            candidate = item;
        }
    }

    return candidate;
}

function getCookie(name) {
    try {
        return getFromString(name, document.cookie);
    } catch (error) {
        return null;
    }
}

function setCookie(name, value) {
    try {
        // eslint-disable-next-line prettier/prettier
        document.cookie =
            name + '=; expires=Mon, 20 Sep 2010 00:00:00 UTC; path=/; domain=' + domain;
        // eslint-disable-next-line prettier/prettier
        document.cookie =
            name +
            '=' +
            value +
            '; expires=Tue, 31 Dec 2030 00:00:00 UTC; path=/; domain=' +
            domain;
    } catch (error) {}
}

function getLocalStorage(name) {
    try {
        return localStorage.getItem(name);
    } catch (error) {
        return null;
    }
}

function setLocalStorage(name, value) {
    try {
        localStorage.setItem(name, value);
    } catch (error) {}
}

function getWindowName(name) {
    try {
        return getFromString(name, window.name);
    } catch (error) {
        return null;
    }
}

function setWindowName(name, value) {
    try {
        window.name = replaceInString(window.name, name, value);
    } catch (error) {
        return null;
    }
}

function getSessionStorage(name) {
    try {
        return sessionStorage.getItem(name);
    } catch (error) {
        return null;
    }
}

function setSessionStorage(name, value) {
    try {
        sessionStorage.setItem(name, value);
    } catch (error) {}
}

function indexedDbRequest(onSuccessCallback) {
    try {
        const indexedDB =
            window.indexedDB ||
            window.mozIndexedDB ||
            window.webkitIndexedDB ||
            window.msIndexedDB;

        if (indexedDB) {
            var ver = 1;
            //FF incognito mode restricts indexedb access
            var request = indexedDB.open('idb_ab', ver);

            request.onerror = function(e) {};

            request.onupgradeneeded = function(event) {
                var db = event.target.result;

                db.createObjectStore(indexedDbTableName, {
                    keyPath: 'name',
                    unique: false
                });
            };

            request.onsuccess = onSuccessCallback;
        }
    } catch (error) {
        return null;
    }
}

function getIndexedDb(name, callback) {
    try {
        var successCallback = function(event) {
            var idb = event.target.result;

            if (!idb.objectStoreNames.contains(indexedDbTableName)) {
                callback(undefined);
            } else {
                var tx = idb.transaction([indexedDbTableName]);
                var objst = tx.objectStore(indexedDbTableName);
                var qr = objst.get(name);

                qr.onsuccess = function(event) {
                    if (qr.result === undefined) {
                        callback(undefined);
                    } else {
                        callback(qr.result.value);
                    }
                };
            }
            idb.close();
        };
        indexedDbRequest(successCallback);
    } catch (error) {}
}

function setIndexedDb(name, value) {
    try {
        var successCallback = function(event) {
            var idb = event.target.result;
            if (idb.objectStoreNames.contains(indexedDbTableName)) {
                var tx = idb.transaction([indexedDbTableName], 'readwrite');
                var objst = tx.objectStore(indexedDbTableName);
                objst.put({
                    name: name,
                    value: value
                });
            }
            idb.close();
        };
        indexedDbRequest(successCallback);
    } catch (error) {}
}
class PersistentCookie {
    constructor(allowSameOrigin) {
        this.cookieSourceList = [
            {
                val: null,
                get: getCookie,
                set: setCookie,
                isAsync: false,
                isSupported: true
            },
            {
                val: null,
                get: getWindowName,
                set: setWindowName,
                isAsync: false,
                isSupported: true
            },
            {
                val: null,
                get: getIndexedDb,
                set: setIndexedDb,
                isAsync: true,
                isSupported: true
            }
        ];
        if (allowSameOrigin) {
            this.cookieSourceList.concat([
                {
                    val: null,
                    get: getLocalStorage,
                    set: setLocalStorage,
                    isAsync: false,
                    isSupported: !!localStorage
                },
                {
                    val: null,
                    get: getSessionStorage,
                    set: setSessionStorage,
                    isAsync: false,
                    isSupported: !!sessionStorage
                }
            ]);
        }
    }

    get(name) {
        var self = this;

        const getPromises = [];
        self.cookieSourceList.forEach(function(cookieSource) {
            if (cookieSource.isSupported) {
                if (cookieSource.isAsync) {
                    const getPromise = new Promise((resolve, reject) =>
                        cookieSource.get(name, value => {
                            cookieSource.val = value;
                            resolve(value);
                        })
                    );
                    getPromises.push(
                        Promise.race([getPromise, timeoutPromise(maxWaitTime)])
                    );
                } else {
                    cookieSource.val = cookieSource.get(name);
                    getPromises.push(Promise.resolve(cookieSource.val));
                }
            }
        });

        return Promise.all(getPromises)
            .then(() => {
                const candidate = getBestCandidate(self.cookieSourceList);

                if (candidate !== undefined) {
                    self.set(name, candidate);
                }

                return candidate;
            })
            .catch(e => Sentry.captureException(e));
    }

    set(name, value) {
        var self = this;
        self.cookieSourceList.forEach(function(cookieSource) {
            if (cookieSource.isSupported) {
                cookieSource.set(name, value);
            }
        });
    }
}

export default PersistentCookie;
